module.exports = __webpack_public_path__ + "img/bg-1.6bbb544b.png";